import { Box } from '@mui/material';
import React from 'react';
import { Badge } from 'src/components-dummy';
import { AnalyticsHeaderRow, AnalyticsTitle } from './AnalyticsHeader.style';

export const AnalyticsHeader = () => {
  return (
    <Box mb={2}>
      <AnalyticsHeaderRow>
        <AnalyticsTitle variant='h4' gutterBottom>
          Analytics
        </AnalyticsTitle>
        <Badge text='Beta' background='primary' className='analytics-beta-badge' />
      </AnalyticsHeaderRow>
    </Box>
  );
};
